export default {
  SHIPPING: 'shipping-address',
  BILLING: 'billing-address',
};
